//开发地址
//export const interfaceUrl='http://localhost:5096/';

//SSO接口地址
export const ssoInterfaceUrl='http://localhost:5097/';

//帮助文档地址--开发地址
//export const helperUrl = 'http://localhost:8082/';

//生产地址
 export const interfaceUrl='http://139.155.137.144:8880/';

//帮助文档地址--生产地址
 export const helperUrl = 'http://139.155.137.144:8883/'
